export enum OpenModal {
  Edit = "Edit",
  Add = "Add",
  View = "View",
  Delete = "Sure",
}
export type SelectOption = { label: string; value: string };
